export const SUPPORTED_LANGUAGES = ["ja", "en", "vi", "my", "id", "ne", "km", "mn", "th", "tl"] as const;

export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const DEFAULT_LANGUAGE: SupportedLanguage = "ja";

/** Native language names — always displayed in their own language, not translated */
export const LANGUAGE_NAMES: Record<SupportedLanguage, string> = {
  ja: "日本語",
  en: "English",
  vi: "Tiếng Việt",
  my: "မြန်မာဘာသာ",
  id: "Bahasa Indonesia",
  km: "ភាសាខ្មែរ",
  mn: "Монгол хэл",
  ne: "नेपाली",
  th: "ภาษาไทย",
  tl: "Tagalog",
};

export const LANGUAGE_STORAGE_KEY = "i18nextLng";
